module.exports = __webpack_public_path__ + "static/media/casem-azul.aa5ef271.png";